(() => {
  
  /* data-handle is being overwritten */
    document.querySelectorAll('.bundle-product-select option').forEach(option => {
    const handle = option.dataset.handle;
    const customized = option.dataset.handleCustomized;

    if (customized && handle !== customized) {
      option.dataset.handle = customized;
    }
  });

  $(".bundle-product-select").on("change", function () {
    updateCurrentSelection();
  });

  $(".bundled-product-select").on("change", function () {
    updateBundledProductImage();
    runBundleUpdate();
    //updateBundledTopupPrice();
  });

  $(".custom-selector .color-box.item").on("click", function () {
    setTimeout(() => {
      runBundleUpdate();
      //updateBundledTopupPrice();
    }, 500);
  });

  $(document).on("click", ".product-group-variants .option-box", function () {

    setTimeout(function () {
      runBundleUpdate();
    }, 50);

  });


  $(".washer_rack_bundle_selector .item").on("click", function () {
    const dataSeries = $(this).attr("data-series");
    const dataProduct = $(this).attr("data-product");
    const dataVariant = $(this).attr("data-variant");

    if (dataVariant) {
    } else if (dataProduct) {
      $(`.washer_rack_bundle_selector .item-group[data-product],
        .washer_rack_bundle_selector .item-group[data-product] .item`).removeClass(
        "active",
      );
      $(
        `.washer_rack_bundle_selector .item-group[data-product="${dataProduct}"],
        .washer_rack_bundle_selector .item-group[data-product="${dataProduct}"] .item:first-child`,
      ).addClass("active");

      updateGroupSelectedText();
    } else if (dataSeries) {
      $(`.washer_rack_bundle_selector .item-group[data-series],
        .washer_rack_bundle_selector .item-group[data-series] .item`).removeClass(
        "active",
      );
      $(
        `.washer_rack_bundle_selector .item-group[data-series="${dataSeries}"],
        .washer_rack_bundle_selector .item-group[data-series="${dataSeries}"] .item:first-child`,
      ).addClass("active");

      const curDataProduct = $(
        `.washer_rack_bundle_selector .item-group.active .item:first-child`,
      ).attr("data-product");
      $(`.washer_rack_bundle_selector .item-group[data-product],
        .washer_rack_bundle_selector .item-group[data-product] .item`).removeClass(
        "active",
      );
      $(
        `.washer_rack_bundle_selector .item-group[data-product="${curDataProduct}"],
        .washer_rack_bundle_selector .item-group[data-product="${curDataProduct}"] .item:first-child`,
      ).addClass("active");

      updateGroupSelectedText();
    }

    updateBundledProductSelect();
  });

  function updateGroupSelectedText() {
    $(".product-selector .item-group.active").each(function (_, itemGroup) {
      $(itemGroup)
        .closest(".product-selector")
        .find("label .sel")
        .text($(itemGroup).find(".item.active").text());
    });
  }

  function updateBundledProductImage() {
    const imageUrl = $(".bundled-product-select")
      .find(`option[value="${getBundledProductVariantId()}"]`)
      .attr("data-image");

    if (imageUrl) {
      $(".washer_rack_bundle_selector .bundled-product img").attr(
        "src",
        imageUrl,
      );
    }
  }

  function updateBundledTopupPrice() {
    //console.log('rund bundle topup');
    const bundleProductPrice = getBundleProductPrice();
    const mainProductPrice = getMainProductPrice();
    const prodHandle = location.pathname.split("/").pop();
      const discount =
        prodHandle == "prism-top-load-washer"
          ? 10000
          : prodHandle == "prism-monsoon-washer"
            ? 30000
            : prodHandle == "prism-washer-dryer-bundles"
              ? 30000
              : prodHandle == "prism-cyclone-washer"
                ? 20000
                : prodHandle == "prism-cyclone-washer-dryer-bundle"
                  ? 20000
                  : 0;
    const diffPrice = bundleProductPrice - mainProductPrice - discount;

    $(".washer_rack_bundle_selector .topup-price").text(
      theme.Currency.formatMoney(diffPrice)?.replace(/\..*/, ""),
    );

    const activeColor = $('.color-selector .item.active').data('color');

    let compareDiff = 0;
    const solarisType = getSolarisType();
    switch (solarisType) {
      case "solaris":
        compareDiff = diffPrice + 5000;
        /*
        if(activeColor == 'Pearl White'){
          $('.preorder-line').show();
        }else{
          $('.preorder-line').hide();
        }
        */
        
        break;
      case "solaris-xl":
        compareDiff = diffPrice + 7000;
        $('.preorder-line').hide();
        break;
      case "solaris-pro":
        compareDiff = diffPrice + 8000;
        $('.preorder-line').hide();
        break;
      case "solaris-pro-xl":
        compareDiff = diffPrice + 10000;
        $('.preorder-line').hide();
        break;
      default:
        compareDiff = diffPrice / 0.9;
        break;
    }

    // const compareDiff = Math.round(diffPrice / 100 / 0.9) * 100;
    $(".topup-wrapper .compare-price").text(
      theme.Currency.formatMoney(compareDiff)?.replace(/\..*/, ""),
    );

    /*
    console.log("TOPUP DEBUG", {
      addonSelected: isAddonSelected(),
      mainVariant: getMainProductVariantId(),
      dataMainVariant: $("#currentSelection").attr("data-main-variant"),
      dataVariant: $("#currentSelection").attr("data-variant"),
      activeColorVariant: $(".custom-selector .color-box.item.active").attr("data-id"),
      bundleVariant: getBundleProductVariantId(),
      mainPrice: getMainProductPrice(),
      bundlePrice: getBundleProductPrice(),
      discount: discount,
      diffPrice: diffPrice
    });
    */
  }

  function getSolarisType() {
    const variantId = getBundleProductVariantId();
    const handle = $(
      `.washer_rack_bundle_selector .bundle-product-select option[value="${variantId}"]`,
    ).attr("data-handle");

    if (handle.includes("solaris-pro-xl")) {
      return "solaris-pro-xl";
    } else if (handle.includes("solaris-pro")) {
      return "solaris-pro";
    } else if (handle.includes("solaris-xl")) {
      return "solaris-xl";
    } else if (handle.includes("solaris")) {
      return "solaris";
    }

    return null;
  }

  function updateBundledProductSelect() {
    const rackVariant = $(
        `.washer_rack_bundle_selector .item-group.active[data-product] .item.active`,
      ).attr("data-variant");
      $(".bundled-product-select").val(rackVariant).change();
    }

  function updateBundleProductSelect() {

    //console.log('🔥 updateBundleProductSelect fired');

    // STEP 1 — base handle
    const baseHandle = getCurrentBundleHandle();
    

    // STEP 2 — addon handle
    const variantId = getBundledProductVariantId();

    const addonHandle = $(
      `.washer_rack_bundle_selector .bundled-product-select option[value="${variantId}"]`
    ).attr("data-handle");

    //console.log("Base Handle:", baseHandle);
    //console.log("Addon Handle:", addonHandle);
    //console.log("Final Handle:", `${baseHandle}-${addonHandle}`);

    if (!baseHandle || !addonHandle) {
      //console.warn('⚠️ Missing base or addon handle');
      return;
    }

    // STEP 3 — combine
    const finalHandle = `${baseHandle}-${addonHandle}`;
    //console.log('🔗 FINAL HANDLE:', finalHandle);

    // STEP 4 — scoped select
    const $select = $('.bundle-product-select.main-product-bundle');

    // 🔥 DEBUG: show all handles
    const allHandles = $select.find('option').map(function () {
      return $(this).data('handle');
    }).get();

    //console.log('📦 Available handles:', allHandles);

    
    $select.find("option").each(function () {
        //console.log($(this).data("handle"));
    });
    // MATCH
    const $match = $select.find(`option[data-handle="${finalHandle}"]`);

    //console.log('🎯 Match count:', $match.length);

    if ($match.length) {

        $select
            .val($match.val())
            .trigger("change");

        // Keep currentSelection in sync with the selected bundle variant
        updateCurrentSelection();

        //console.log("✅ SELECT UPDATED:", $match.val());
        //console.log(finalHandle);

    } else {

        //console.error("❌ NO MATCH for:", finalHandle);

    }
  }
  
  function getMainProductVariantId() {

    return (
        $("#currentSelection").attr("data-main-variant") ||
        $(".custom-selector .color-box.item.active").attr("data-id") ||
        $("#currentSelection").attr("data-variant")
    );

}

  function getBundleProductVariantId() {
    return $(".washer_rack_bundle_selector .bundle-product-select").val();
  }

  function getBundledProductVariantId() {
    return $(".washer_rack_bundle_selector .bundled-product-select").val();
  }

  function getMainProductPrice() {
    const variantId =
      $("#currentSelection").attr("data-main-variant") ||
      $(".custom-selector .color-box.item.active").attr("data-id");

    const $option = $(
      `#ProductSelect-product-template option[value="${variantId}"]`
    );

    const price = Number(
      String($option.attr("data-price") || "0").replace(",", "")
    );

    const voucher = Number(
      String($option.attr("data-variant-voucher") || "0").replace(",", "")
    );

    return (price - voucher) * 100;
  }

  function getBundleProductPrice() {
    const variantId = getBundleProductVariantId();
    return Number(
      $(
        `.washer_rack_bundle_selector .bundle-product-select option[value="${variantId}"]`,
      ).attr("data-price"),
    );
  }

  function isAddonSelected() {

    // Legacy bundled-product selection
    const isSelected = $(".washer_rack_bundle_selector .bundled-product")
        .hasClass("selected");

    // Dynamic Option Selector selection
    const hasDynamicBundle =
        !!$("#ProdBundle").attr("data-gp2-id");

    const selected = isSelected || hasDynamicBundle;

    // ================================
    // Prevent duplicate groupsell
    // ================================
    if (selected) {

        const prodBundleVid = $("#ProdBundle").attr("data-vid");
        const selectedgroupsell = $(".selectedgroupsell").text().trim();

        if (
            prodBundleVid &&
            selectedgroupsell &&
            prodBundleVid === selectedgroupsell
        ) {
            $(".selectedgroupsell").text("");
        }
    }

    return selected;

}

  function updateCurrentSelection() {

      let variantId = "";

      if (isAddonSelected()) {
          variantId = getBundleProductVariantId();
          console.log('selected');
      } else {
          variantId = getMainProductVariantId();
          console.log('main prod id');
      }

      $("#currentSelection")
          .attr("data-variant", variantId);

  }
  /*
  function getCurrentBundleHandle() {

    const $container = $('.product-group-variants').first();

    if (!$container.length) {
      //console.error('❌ No .product-group-variants found');
      return '';
    }

    const washer = $container.find('.type-box.active').data('type');

    let color = $container.find('.color-box.active').data('display') || '';
    color = color.toLowerCase().replace(/\s+/g, '-');

    const parts = [];

    if (washer && color) {
      parts.push(`${washer}-${color}`);
    }
    // 🔥 UNIVERSAL DRYER DETECTION

    let dryer = '';

    // 1️⃣ check original selector (dummy-box)
    const $dummyDryer = $container.find('.dummy-box.active');

    if ($dummyDryer.length) {
      dryer = $dummyDryer.data('dryer') || '';
    }

    // 2️⃣ check addon selector (new UI)
    if (!dryer) {
      const $addonDryer = $('.addon-box.active');

      if ($addonDryer.length) {
        const raw = $addonDryer.data('type') || '';

        // convert dh-100-10kg → dh100
        const match = raw.match(/dh[-\s]?(\d+)/i);

        if (match) {
          dryer = `dh${match[1]}`;
        }
      }
    }

    // 3️⃣ apply if found
    if (dryer) {
      parts.push(`${dryer}-${color}`);
    }

    //console.log('🌀 DRYER:', dryer);

    const finalHandle = parts.join('-');

    //console.log('🧩 BASE HANDLE:', finalHandle);

    return finalHandle;
  }
  */
  function getCurrentBundleHandle() {

    // ========================================================
    // Dynamic Option Selector
    // ========================================================

    const values = {};
    const extras = [];
    let colour = "";

    $(".product-group-variants .option-box.active").each(function () {

        const $item = $(this);

        const group = String($item.data("group") || "")
            .trim()
            .toLowerCase();

        let value = String($item.data("value") || "")
            .trim()
            .toLowerCase();

        if (!group || !value) return;

        // Colour
        if (group === "colour" || group === "color") {

            colour = value.replace(/\s+/g, "-");
            return;

        }

        // Store by group key
        values[group] = value.replace(/[\s-]+/g, "");

    });

    const parts = [];

    // ========================================================
    // Washer + Colour
    // ========================================================

    if (values.washer) {

        parts.push(values.washer);

        if (colour) {
            parts.push(colour);
        }

        delete values.washer;

    }

    // ========================================================
    // Dryer + Colour
    // ========================================================

    if (values.dryer) {

        parts.push(values.dryer);

        if (colour) {
            parts.push(colour);
        }

        delete values.dryer;

    }

    // ========================================================
    // Remaining Dynamic Groups
    // (Series, Length, etc.)
    // ========================================================

    Object.keys(values).forEach(function (key) {

        extras.push(values[key].replace(/\s+/g, "-"));

    });

    parts.push(...extras);

    // ========================================================
    // Final
    // ========================================================

    if (parts.length) {

        return parts.join("-");

    }

    // ========================================================
    // Legacy Selector Fallback
    // ========================================================

    const $container = $(".product-group-variants").first();

    if (!$container.length) {
        return "";
    }

    const washer = $container.find(".type-box.active").data("type");

    let color = $container.find(".color-box.active").data("display") || "";
    color = color.toLowerCase().replace(/\s+/g, "-");

    const legacyParts = [];

    if (washer && color) {
        legacyParts.push(`${washer}-${color}`);
    }

    let dryer = "";

    const $dummyDryer = $container.find(".dummy-box.active");

    if ($dummyDryer.length) {
        dryer = $dummyDryer.data("dryer") || "";
    }

    if (!dryer) {

        const $addonDryer = $(".addon-box.active");

        if ($addonDryer.length) {

            const raw = $addonDryer.data("type") || "";
            const match = raw.match(/dh[-\s]?(\d+)/i);

            if (match) {
                dryer = `dh${match[1]}`;
            }

        }

    }

    if (dryer) {
        legacyParts.push(`${dryer}-${color}`);
    }

    return legacyParts.join("-");

  }
  $(document).on('click', '.bundled-addon-selectors, .addon-box, .dummy-box', function () {

  // wait for UI class updates
  setTimeout(() => {

    const hasBundle = $('.bundled-product.selected').length > 0;

    //console.log('🧪 Dryer interaction | hasBundle:', hasBundle);

    // ❗ Only run if bundle exists
    if (!hasBundle) {
      //console.log('⛔ Skipping — no bundled-product selected');
      return;
    }

    //console.log('🚀 Running handle builder (dryer allowed)');
    runBundleUpdate();

  }, 50);

});
$(document).on('click', '.bundled-product', function (e) {

  // 🔥 optional: avoid double firing when clicking inner selectors
  if ($(e.target).closest('.options').length) return;

  setTimeout(() => {
    //console.log('📦 bundled-product container clicked');

    runBundleUpdate();
  }, 50);

});


function runBundleUpdate() {
  console.log('🔁 runBundleUpdate');

  updateBundleProductSelect();
  updateAddOnDisplay();
  updateBundledTopupPrice();
}

/* function taken from addon-by-variants */
const curSelection = $("#currentSelection");

  function deselectAddOns() {
  if (window._skipGlobalDeselect) return;

    $(".addon_by_variants-container .addon input").each(function () {
      $(this).prop("checked", false).trigger("change");
    });
  }

  function updateAddOnDisplay() {
    //console.log('ADDON DISPLAY WR BUNDLE');
    var curSelection = $("#currentSelection");
    const variant = $("#currentSelection").attr("data-variant");

    if (!variant) {
        //console.warn("currentSelection/data-variant not ready");
        return;
    }else{
      //console.log('variant found:'+ variant);
    }
    $(".addon_by_variants-container .addon").each(function () {
      const variantIds_string = $(this).data("main-product-variant-ids");
      if (variantIds_string) {
        const variantIds = variantIds_string.toString().split(",");
        if (
          variantIds.includes($(curSelection).attr("data-variant").toString())
        ) {
          $(this).removeClass("hide");
        } else {
          $(this).addClass("hide");
        }
      } else {
        $(this).addClass("hide");
      }
    });
    deselectAddOns();
  }
   
  updateAddOnDisplay();

  $(document).on('click', '.bundled-addon-selectors .addon-box', function (e) {
    setTimeout(() => {
      ////console.log('📦 bundled-product container clicked');
      //console.log('bundle selector - not triple')
      updateAddOnDisplay();
    }, 50);
  });
  setTimeout(() => {
    console.log('initial display');
      runBundleUpdate();
    }, 50);
  
})();
//$('.color-space-grey').click();

